<template>
    <div class="portfolio-section">  
        <PortfolioItem :items="item"></PortfolioItem>

        <section >
            <PortfolioGrid :portfolio=0 :remove=[20,17,1,9,4,2,6,8] :light="false"></PortfolioGrid>
        </section>
    </div>
</template>

<script>

import PortfolioItem from './../layout/PortfolioItem'
import PortfolioGrid from './../layout/PortfolioGrid'

export default {
    components : {
        PortfolioItem,
        PortfolioGrid
    },
    data() {
        return {
            item : ['backbone', 'appac', 'reucirs', 'ixxo', 'jarod', 'jmcars', 'safe', 'aktid']
        }
    }    
}
</script>

<style scoped>
    .portfolio-section {
        display:flex;
        flex-direction: column;
    }

</style>